// ============================================================
// Income Category Modal (Create & Edit Income Category)
// ============================================================

import { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Stack, FormControlLabel, Switch, CircularProgress } from '@mui/material';

export function IncomeCategoryModal({ open, onClose, onSubmit, loading, category }) {
  const [name, setName] = useState('');
  const [isActive, setIsActive] = useState(true);

  useEffect(() => {
    if (category) {
      setName(category.name || '');
      setIsActive(category.is_active !== undefined ? Boolean(category.is_active) : true);
    } else {
      setName('');
      setIsActive(true);
    }
  }, [category, open]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name.trim()) return;

    const payload = category
      ? { name: name.trim(), is_active: isActive }
      : { name: name.trim() };

    onSubmit(payload);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <form onSubmit={handleSubmit}>
        <DialogTitle fontWeight={700}>
          {category ? 'Edit Income Category' : 'Create Income Category'}
        </DialogTitle>
        <DialogContent dividers>
          <Stack spacing={2.5} sx={{ mt: 1 }}>
            <TextField
              label="Category Name *"
              fullWidth
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g. Grants, Donations, Sale of Asset"
            />

            {category && (
              <FormControlLabel
                control={
                  <Switch
                    checked={isActive}
                    onChange={(e) => setIsActive(e.target.checked)}
                    color="primary"
                  />
                }
                label={isActive ? 'Active Category' : 'Inactive Category'}
              />
            )}
          </Stack>
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button onClick={onClose} color="inherit" disabled={loading}>
            Cancel
          </Button>

          <Button
            type="submit"
            variant="contained"
            disabled={loading || !name.trim()}
            startIcon={loading ? <CircularProgress size={16} color="inherit" /> : null}
            sx={{ fontWeight: 600, px: 3 }}
          >
            {loading ? 'Saving...' : category ? 'Update Category' : 'Save Category'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
